import { render, staticRenderFns } from "./UserManagent.vue?vue&type=template&id=f9595cb2"
import script from "./UserManagent.vue?vue&type=script&lang=js"
export * from "./UserManagent.vue?vue&type=script&lang=js"
import style0 from "./UserManagent.vue?vue&type=style&index=0&id=f9595cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports